import r2wc from '@r2wc/react-to-web-component';
import React from 'react';
import LocaleAndThemeProvider from 'src/providers/LocaleAndThemeProvider/LocaleAndThemeProvider.tsx';
import ItineraryHeader, {
  ItineraryHeaderProps,
} from '../composites/ItineraryHeader/ItineraryHeader';

const TripHeroGalleryWrapper: React.FC<ItineraryHeaderProps> = (props) => {
  return (
    <LocaleAndThemeProvider>
      <ItineraryHeader {...props}></ItineraryHeader>
    </LocaleAndThemeProvider>
  );
};

export const TripHeroGalleryComponent = r2wc(TripHeroGalleryWrapper, {
  props: {
    title: 'string',
    standardTitle: 'string',
    alternativeTitle: 'string',
  },
});
export default TripHeroGalleryComponent;
